"use client";
import * as React from "react";
import { useState, useEffect } from "react";

function AboutOverview() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative py-16 lg:py-20 bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-50/40 overflow-hidden" aria-labelledby="about-overview-heading">
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden" aria-hidden="true">
        <div className="absolute top-1/4 left-1/4 w-72 h-72 lg:w-80 lg:h-80 md:w-60 md:h-60 sm:w-40 sm:h-40 bg-blue-200/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-72 h-72 lg:w-80 lg:h-80 md:w-60 md:h-60 sm:w-40 sm:h-40 bg-indigo-200/20 rounded-full blur-3xl"></div>
      </div>

      <div className="container max-w-7xl mx-auto px-4 lg:px-6 md:px-4 sm:px-3 relative">
        <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>

          {/* Title Section */}
          <header className="text-center mb-12 lg:mb-16">
            <div className="inline-flex items-center px-4 py-2 lg:px-6 lg:py-2 md:px-4 md:py-1.5 sm:px-3 sm:py-1 bg-[#1719A8]/90 backdrop-blur-md border border-[#1719A8]/60 rounded-full mb-4 lg:mb-6 shadow-lg">
              <span className="w-2 h-2 bg-white rounded-full mr-3 animate-pulse"></span>
              <span className="text-xs md:text-sm lg:text-sm sm:text-xs text-white font-semibold uppercase tracking-wider">
                About Vasta INFOTECH
              </span>
            </div>

            <h1 id="about-overview-heading" className="text-3xl lg:text-5xl md:text-3xl sm:text-2xl font-bold text-slate-900 mb-4 lg:mb-3 leading-tight">
              Custom Software Development
              <span className="block leading-normal bg-gradient-to-r from-orange-500 via-yellow-500 to-green-500 bg-clip-text text-transparent">
                & IT Solutions Company
              </span>
            </h1>
          </header>

          {/* Row 1: Image Left, Content Right */}
          <div className="mb-16 lg:mb-20">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
              {/* Image */}
              <div className="order-2 lg:order-1">
                <div className="relative h-64 md:h-80 lg:h-96 group">
                  <img
                    src="https://cdn.acsdev.in/Vasta/t3.png"
                    alt="Vasta software development services and solutions"
                    className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105 rounded-2xl"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-blue-800/5 via-transparent to-transparent rounded-2xl"></div>
                </div>
              </div>

              {/* Content */}
              <div className="order-1 lg:order-2">
                <div className="space-y-6 text-lg lg:text-xl md:text-base sm:text-sm text-slate-600 leading-relaxed">
                  <p>
                    Vasta is a custom software development and deployment company owned by IT Solutions professionals. We provide comprehensive software development services with a structured approach to develop custom software applications. Our cloud computing services offer Software as a Service (SaaS) specialized in automatic cloud upgrades and protection from data loss, Infrastructure as a Service (IaaS) that works on a pay-as-you-go basis, and Platform as a Service (PaaS) specialized in on-demand platform hardware, complete software stack, infrastructure, and development tools for running, developing, and managing applications without the cost, complexity, and inflexibility of maintaining that platform on-premises.
                  </p>

                  <p>
                    Vasta being a custom software development company deals with designs and develops custom software applications, frameworks, and tools that help solve problems or achieve specific outcomes of Create and Develop, Test and Troubleshoot. Our software development services include various products and applications like desktop and mobile application development, services, sales and software systems related data processing and IT consulting, management consulting, various professional skills training and outsource services.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Row 2: Content Left, Image Right */}
          <div className="mb-16 lg:mb-20">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
              {/* Content */}
              <div className="order-2 lg:order-1">
                <div className="space-y-6 text-lg lg:text-xl md:text-base sm:text-sm text-slate-600 leading-relaxed">
                  <p>
                    Our Technology Division provides various kinds of software IT solutions services that include: Custom Software Development, various desktop and mobile applications development, software product development, database management and administration especially Oracle and Big Data, Business Intelligence Solutions, Geographic Information Systems, infrastructure and cybersecurity solutions management, cloud computing services specialized in SaaS, quality testing both manual and automation, Near Field Communication, web digital marketing services with Search Engine Optimization.
                  </p>

                  <p>
                    We strongly recommend Agile Methodology of Software Development Life Cycle. Even though some of our stakeholders prefer to work with us on traditional methodology like: Prototypes, Waterfall, Spiral, and V-Model and modern methodology like DevOps.
                  </p>
                </div>
              </div>

              {/* Image */}
              <div className="order-1 lg:order-2">
                <div className="relative h-64 md:h-80 lg:h-96  group">
                  <img
                    src="https://cdn.acsdev.in/Vasta/c4.png"
                    alt="Vasta technology solutions and development methodology"
                    className="w-full h-full p-4 object-contain transition-transform duration-500 group-hover:scale-105 "
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-blue-800/5 via-transparent to-transparent rounded-2xl"></div>
                </div>
              </div>
            </div>
          </div>

          {/* Row 3: Full Width Content */}
          <div className="max-w-6xl mx-auto">
            <div className="space-y-6 lg:space-y-5 mb-3 text-lg lg:text-xl md:text-base sm:text-sm text-slate-600 leading-relaxed">
              <p>
                Our consulting services provide various services like business analysis consulting, enterprise Business Process Management (BPM), corporate change management consulting, strategy management consulting, various risk management implementation consulting, pre-sales consulting, supply chain management consulting, workforce management consulting, taxation consulting, investment banking consulting services and procurement management consulting.
              </p>

              <p>
                Our outsource division caters to various Business Process Outsource (BPO), Knowledge Process Outsource (KPO), Recruitment Process Outsource (RPO), staff augmentation, call centers, back office - Information Technology enabled services, Legal Process Outsource (LPO), resume writing, preparation and background verification.
              </p>

              <p>
                We offer in-depth support for current technologies and project management with committed quality of service. Finally, one among the most important variations is that we focus equally on individuals and processes as well as the tools and technology involved in the solutions we bring our clients. This allows us to develop enduring relationships with our clients while viewing their unique business challenges and opportunities as our own.
              </p>
            </div>
          </div>

        </div>
      </div>

      {/* Bottom Wave SVG */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1200 80" className="w-full h-auto">
          <path
            d="M0,40 C300,80 500,0 800,40 C1000,70 1100,20 1200,40 L1200,80 L0,80 Z"
            fill="#0b1026"
          />
        </svg>
      </div>
    </section>
  );
}

export default AboutOverview;
